import { IdValue } from '../../../shared/models/id-value.model';

export const propertyTypes: IdValue[] = [
  new IdValue(0, '0', 'Select'),
  new IdValue(1, 'PR', 'Primary Residence'),
  new IdValue(2, 'SH', 'Second Home'),
  new IdValue(3, 'IP', 'Investment Property'),
  new IdValue(4, 'SR', 'FHA Secondary Residence'),
];

export const propertyTitleTypes: IdValue[] = [
  new IdValue(0, '0', 'Select'),
  new IdValue(1, 'S', 'Solely'),
  new IdValue(2, 'SP', 'Jointly w/ Spouse'),
  new IdValue(3, 'O', 'Jointly w/ Another Person'),
];

export const bankruptcyTypes: IdValue[] = [
  new IdValue(0, '0', 'Select'),
  new IdValue(1, '1', 'Chapter 7'),
  new IdValue(2, '2', 'Chapter 11'),
  new IdValue(4, '4', 'Chapter 12'),
  new IdValue(8, '8', 'Chapter 13'),
];
